var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{ref:"el",tag:"component",class:{
    'bcx-markdown--restricted': _vm.mode === 'restricted',
    'bcx-markdown': !_vm.unstyled
  }})
}
var staticRenderFns = []

export { render, staticRenderFns }